import React, { useEffect, useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { Menu, X, Search } from "lucide-react";
import { navLinks } from "../mock";
import Logo from "./Logo";
import SearchDialog from "./SearchDialog";

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") {
        e.preventDefault();
        setSearchOpen(true);
      }
      if (e.key === "/" && document.activeElement?.tagName !== "INPUT" && document.activeElement?.tagName !== "TEXTAREA") {
        e.preventDefault();
        setSearchOpen(true);
      }
    };
    document.addEventListener("keydown", handler);
    return () => document.removeEventListener("keydown", handler);
  }, []);

  return (
    <header className="sticky top-0 z-50 bg-[#f5efe6] border-b border-[#ecdfc9]">
      <div className="max-w-7xl mx-auto px-6 py-3 flex items-center justify-between">
        <Link to="/" className="flex items-center">
          <Logo variant="dark" />
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((l) => (
            <NavLink
              key={l.name}
              to={l.path}
              className={({ isActive }) =>
                `text-sm font-semibold tracking-wider transition-colors pb-1 ${
                  isActive
                    ? "text-neutral-900 border-b-2 border-teal-500"
                    : "text-neutral-700 hover:text-neutral-900"
                }`
              }
            >
              {l.name}
            </NavLink>
          ))}
        </nav>

        <Link
          to="/contact"
          className="hidden md:inline-flex items-center bg-teal-500 hover:bg-teal-600 transition-colors text-white text-sm font-semibold px-5 py-2.5 rounded-full shadow-sm"
        >
          Get Free Consultation*
        </Link>

        <button
          onClick={() => setSearchOpen(true)}
          className="hidden md:inline-flex items-center gap-2 ml-2 border border-neutral-300 hover:border-teal-500 text-neutral-600 hover:text-teal-600 px-3 py-2 rounded-full text-xs font-semibold transition-colors"
          aria-label="Search"
        >
          <Search className="w-4 h-4" />
          <kbd className="hidden lg:inline text-[10px] px-1.5 py-0.5 rounded bg-neutral-100 border border-neutral-200 text-neutral-500">
            /
          </kbd>
        </button>

        <button
          onClick={() => setSearchOpen(true)}
          className="md:hidden ml-2 text-neutral-800"
          aria-label="Search"
        >
          <Search className="w-5 h-5" />
        </button>

        <button
          onClick={() => setOpen(!open)}
          className="md:hidden ml-2 text-neutral-900"
          aria-label="Toggle menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-[#f5efe6] border-t border-[#ecdfc9] px-6 py-4 space-y-3">
          {navLinks.map((l) => (
            <NavLink
              key={l.name}
              to={l.path}
              onClick={() => setOpen(false)}
              className="block text-sm font-semibold tracking-wider text-neutral-800"
            >
              {l.name}
            </NavLink>
          ))}
          <Link
            to="/contact"
            onClick={() => setOpen(false)}
            className="inline-flex bg-teal-500 text-white text-sm font-semibold px-5 py-2.5 rounded-full"
          >
            Get Free Consultation*
          </Link>
        </div>
      )}

      <SearchDialog open={searchOpen} onClose={() => setSearchOpen(false)} />
    </header>
  );
};

export default Navbar;
